import React, { memo } from 'react'
import MarkdownRender from 'components/Luxkit/MarkdownRender'
import { getFinePrintSectionIcon } from 'lib/tours/getTourV2Icons'
import Accordion from 'components/Luxkit/Accordion'

interface Props {
  finePrintSection: Tours.V2OfferFinePrintSection
}

function TourV2FinePrintSection(props: Props) {
  const { finePrintSection } = props

  const Icon = getFinePrintSectionIcon(finePrintSection.category)

  return (
    <Accordion
      size="large"
      heading={finePrintSection.title}
      icon={<Icon aria-hidden="true" />}
    >
      <MarkdownRender content={finePrintSection.body} />
    </Accordion>
  )
}

export default memo(TourV2FinePrintSection)
